import styled from '@emotion/styled'
import { evalCondition, notifyParent } from 'mailup-react-helpers'
import {
  Panel,
  Grid,
  GridCell,
  Text,
  SPACING_8,
  SpacingVertical,
  SPACING_16,
  TEXT_VARIANT_BOLD,
  SkeletonLoader,
  Link
} from 'mailup-web-components'
import { pageDataState } from 'Pages/SmsQueue/recoil/states/state'

import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import IconCredits from './IconCredits'
import IconPeople from './IconPeople'

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
`
const StyledCol = styled.div`
  display: flex;
  flex-direction: column;
`
const StyledSkeletonLoader = styled(SkeletonLoader)`
  flex-basis: 20%;
  top: 2px;
  position: relative;
  margin-left: 8px;
`

const StyledTextTotalCredits = styled(Text)`
  margin-left: 8px;
`

const StyledText = styled(Text)`
  font-size: 36px !important;
  line-height: 1em !important;
  color: #3b3b3b !important;
  // margin-top: 12px;
  // margin-bottom: 5px;
`
export const Credits = () => {
  const intl = useIntl()
  const {
    TotalCredits,
    SendingsTotalCost,
    CountRecipientsToBeQueued
  } = useRecoilValue(pageDataState)
  const showMshop = evalCondition(
    'uo:GEST AND NOT c:IsRetailer AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP'
  )

  const goToMshop = () => {
    notifyParent('redirectMainFrame', ['mshop_Redirector.aspx?t=mshopcr'])
  }

  return (
    <Panel>
      <Grid cols={2}>
        <GridCell>
          <StyledRow>
            <IconCredits />

            <StyledCol>
              <Text>
                {intl.formatMessage({ id: 'Load.QueueSms.TempoStimato' })}
              </Text>
              <SpacingVertical variant={SPACING_8} />
              {SendingsTotalCost != null ? (
                <StyledText>
                  {Math.ceil(parseFloat(SendingsTotalCost))}
                </StyledText>
              ) : (
                <StyledSkeletonLoader
                  width={'100'}
                  height={'100'}
                  type='default'
                  variant='onwhite'
                />
              )}
              <SpacingVertical variant={SPACING_16} />
              <StyledRow>
                <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                  {intl.formatMessage({ id: 'Load.QueueSms.RemainingCredits' })}
                </Text>
                {TotalCredits != null ? (
                  <>
                    <StyledTextTotalCredits
                      htmlElement='span'
                      variant={TEXT_VARIANT_BOLD}
                    >
                      {Math.ceil(parseFloat(TotalCredits))}
                    </StyledTextTotalCredits>
                  </>
                ) : (
                  <StyledSkeletonLoader
                    width={'100'}
                    height={'100'}
                    type='default'
                    variant='onwhite'
                  />
                )}
              </StyledRow>

              {showMshop ? (
                <Text>
                  {intl.formatMessage(
                    {
                      id: 'Load.QueueSms.InfoUpg'
                    },
                    {
                      UPGRADELINK: (
                        <Link variant='highlight' onClick={goToMshop}>
                          {intl.formatMessage({
                            id: 'Load.Common.Upgrade'
                          })}
                        </Link>
                      )
                    }
                  )}
                </Text>
              ) : (
                <Text>
                  {intl.formatMessage({
                    id: 'Load.QueueSms.InfoUpgWhiteLabel'
                  })}
                </Text>
              )}
            </StyledCol>
          </StyledRow>
        </GridCell>
        <GridCell>
          <StyledRow>
            <IconPeople />

            <StyledCol>
              <Text>
                {intl.formatMessage({ id: 'Load.MailupCommon.Recipients' })}
              </Text>
              <SpacingVertical variant={SPACING_8} />
              {CountRecipientsToBeQueued != null ? (
                <StyledText>{CountRecipientsToBeQueued}</StyledText>
              ) : (
                <StyledSkeletonLoader
                  width={'100'}
                  height={'100'}
                  type='default'
                  variant='onwhite'
                />
              )}
              <SpacingVertical variant={SPACING_16} />
            </StyledCol>
          </StyledRow>
        </GridCell>
      </Grid>
    </Panel>
  )
}

export default Credits
